import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { MeuFaturamentoRoutingModule } from './meu-faturamento-routing.module';
import { MeuFaturamentoComponent } from './meu-faturamento.component';
import { ContaService } from '../../shared/services/conta/conta.service';
import { DirectivesModule } from '../../shared/directives/directives.module';
import { FormsModule } from '@angular/forms';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    MeuFaturamentoRoutingModule,
    HttpClientModule,
    DirectivesModule,
    FormsModule,
    NgxMaskDirective
  ],
  declarations: [
    MeuFaturamentoComponent,
  ],
  providers: [
    ContaService,
    provideNgxMask()
  ]
})
export class MeuFaturamentoModule { }
